export default __webpack_public_path__ + "static/media/TicTac-Learn-Website-27-1.a4cc9535.png";